export default "__VITE_ASSET__3pgFEBEC__"